import type { ReactNode } from "react";

import { InfoCircleOutlined } from "@ant-design/icons";
import { Skeleton, Tooltip, Typography } from "antd";

import type { MetricBreakdownItem } from "../../../../utils";

import styles from "./MetricBreakdownGrid.module.scss";

type MetricBreakdownGridProps = {
    loading: boolean;
    items: MetricBreakdownItem[];
    title?: string;
    tooltip?: ReactNode;
    testId?: string;
};

export const MetricBreakdownGrid = ({
    loading,
    items,
    title,
    tooltip,
    testId = "metric-breakdown-grid",
}: MetricBreakdownGridProps): JSX.Element => {
    if (loading) {
        return (
            <div data-testid={`${testId}-loading`}>
                <Skeleton active paragraph={{ rows: title ? 5 : 4, width: "100%" }} />
            </div>
        );
    }

    return (
        <div className={styles.metricBreakdown} data-testid={testId}>
            {title ? (
                <div className={styles.titleRow}>
                    <Typography.Text className={styles.title}>{title}</Typography.Text>
                    {tooltip ? (
                        <Tooltip title={tooltip} trigger="hover" placement="bottom">
                            <InfoCircleOutlined className={styles.info} />
                        </Tooltip>
                    ) : null}
                </div>
            ) : null}
            <div className={styles.grid}>
                {items.map(({ label, value }) => (
                    <div key={label} className={styles.metricRow}>
                        <Typography.Text className={styles.value}>{value}</Typography.Text>
                        <Typography.Text className={styles.label}>{label}</Typography.Text>
                    </div>
                ))}
            </div>
        </div>
    );
};
